import config from 'appconfig';
import environment from 'appconfig/environment';
import uuid from 'uuid';

export const statsigConfig = {
  sdkKey: config.statsigClientSDK,
  waitForInitialization: true,
  options: {
    environment: { tier: environment.toLowerCase() },
  },
  user: { userID: uuid() },
};
